export default {
    categories: [],
    stores: [],
    products: []
  }
